/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_EvidenceInputs */

const vi_care_log_evidence = /** @type {(inputs: Care_Log_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh/Video minh chứng`)
};

/**

* @param {Care_Log_EvidenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_evidence = /** @type {((inputs?: Care_Log_EvidenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_EvidenceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_evidence(inputs)
});